import { notFound } from 'next/navigation';

export function allowedWithPermissionsNext(permissions: string[], validPermissions: string[]) {
  const hasPermission = permissions.some((perm) => validPermissions.includes(perm.trim()));
  if (!hasPermission) return notFound();
}
